import React from "react";
import { useOutletContext } from "react-router-dom";
import { KeyValue, Note, PageHead, RailCard, DeskSupport } from "@/components/portal/crm/kit";
import { DocumentsPanel } from "@/components/portal/DocumentsPanel";
import { AdminPreviewBanner } from "@/pages/introducer/Portal";
import { ukDayYear } from "@/lib/time";

export default function Documents() {
  const { me, reload, isAdmin } = useOutletContext();

  return (
    <>
      {isAdmin && <AdminPreviewBanner what="lender desk" />}

      <PageHead
        eyebrow="Executed, filed, downloadable"
        title="Documents"
        lede="Your panel agreement and the mutual NDA. Connexis has already signed both — countersign online and keep an executed copy."
        testId="lender-documents-head"
      />

      <div className="grid items-start gap-7 xl:grid-cols-[minmax(0,1fr)_320px]">
        <div className="min-w-0">
          <div id="documents" className="scroll-mt-24">
            <DocumentsPanel me={me} onChanged={reload} />
          </div>
        </div>

        <div className="space-y-4">
          <RailCard title="Your desk on file" testId="lender-documents-company">
            <KeyValue label="Company" value={me?.company_name || "—"} />
            <KeyValue label="Type" value={me?.company_type || "—"} />
            <KeyValue label="Contact" value={me?.contact_name || "—"} />
            <KeyValue label="Email" value={me?.email || "—"} />
            <KeyValue label="Companies House" value={me?.company_number || "—"} />
            <KeyValue label="On the panel since" value={ukDayYear(me?.created_at, "—")} />
          </RailCard>

          <RailCard title="Paperwork" testId="lender-documents-status">
            <KeyValue label="Agreement" value={me?.agreement?.status === "signed" ? "Signed" : "Awaiting you"} tone={me?.agreement?.status === "signed" ? "green" : undefined} />
            <KeyValue label="Version" value={`v${me?.agreement_version || 1}`} />
          </RailCard>

          <DeskSupport body="Need it on your own paper, or signed by a different director? Tell the desk and we'll reissue it." />
          <Note>Every executed document carries the signature, the date, the IP address and the document version.</Note>
        </div>
      </div>
    </>
  );
}
